/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    setDevelopment({ commit }){
        commit('SET_DEVELOPMENT')
    },
    setZoom({ commit }, data){
        commit('UPDATE_ZOOM', data)
    },
    zoomIn({ commit }){
        commit('ZOOM_IN')
    },
    zoomOut({ commit }){
        commit('ZOOM_OUT')
    },
    setLoginStatus({ commit }, data){
        commit('SET_LOGIN_STATUS', data)
    },
    updateCompanyUserPermissions({ commit }, data){
        commit('SET_USER_PERMISSIONS', data)
    },
    updateTasksInConfirmation({ commit }, data){
        commit('SET_TASKS_IN_CONFIRMATION', data)
    },
    updateUserData({ commit }, data){
        commit('UPDATE_USER_DATA', data)
    },
    setLanguage({ commit }, data) {
        commit('language', data)
    }
};

export default actions
